export enum Themes {
	dark = 'dark',
	light = 'light',
	auto = 'auto',
}
